module.exports = __webpack_public_path__ + "static/media/ctech.e1d7589f.png";